<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp;Note Template List</h2>
    </div>
</div>

<!--<div class="card  pt-0 pb-0 mb-2">
    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-10 mb-0">
            <span class="ui-float-label">
                <p-dropdown *ngIf="reportCategoryList" dataKey="reportcategoryid" [options]="reportCategoryList" optionLabel="reportcategoryname" placeholder="Report Category" class="ui-fluid" [(ngModel)]="selectedReportCategory" (onChange)="searchonId(selectedReportCategory)"></p-dropdown>
            </span>
        </div>

        <div class="field col-12 md:col-2 alignRight pt-2 mb-2">

            <button pButton type="button" pTooltip="Adds Reports" label="Add Reports" pTooltipPosition="true" icon="pi pi-book" [disabled]="selectedReportCategory == null" class="ui-button-plain buttonWidth-14" (click)="onAddReports()"></button>
        </div>

    </div>
</div>-->
<!--<p-table [resetPageOnSort]="false" [columns]="cols" [value]="notes" selectionMode="single"
         [lazy]="false"

         [style]="{'margin-bottom':'20px'}">-->
<!--<div class="card col-12 pt-0 pb-0 mb-2">
    <div class="p-fluid formgrid grid" style="justify-content: space-between">
        <div class="field col-12 md:col-4 xl:col-4 pt-3 mb-3">
            <span class="ui-float-label">
                <p-dropdown [options]="categoriesList"
                            [formControl]="categoryControl"
                            dataKey="categoryId"
                            placeholder="Select category"
                            optionLabel="categoryName"
                            filterBy="categoryName"
                            [showClear]="true"
                            [filter]="true"
                            (onClear)="selectAllCategories()"></p-dropdown>
            </span>
        </div>

        <div class="field col-2 md:col-4 lg:col-4 xl:col-3 alignRight pt-3 mb-2">
            <button pButton
                    type="button"
                    pTooltip=""
                    label="Create Note Template"
                    pTooltipPosition="true"
                    icon="pi pi-book"
                    [disabled]="!categoryControl.value"
                    class="ui-button-plain buttonWidth-14 GreyButton"
                    (click)="onAddNotesTemplate()"></button>
        </div>
    </div>
</div>

<p-table
  *ngIf="notesList"
  [columns]="cols"
  [value]="notesList.data"
  selectionMode="single"
  dataKey="notesCategoryId"
  [(selection)]="selectedNotes"
  [paginator]="showRecords"
  [rows]="rows"
         [(first)]="first"
  [style]="{ 'margin-bottom': '20px' }"
>
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="showRecords == true">
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>

      <th class="col-3 md:col-3" style="text-align: center !important">
        Actions
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        {{ rowData[col.field] }}
      </td>

      <td style="text-align: center !important">
        <button
          pButton
          type="button"
          icon="pi pi-pencil"
          pTooltip="Edit"
          class="p-button-link"
          (click)="onEditNote(rowData)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          (click)="onDeleteNote($event, rowData)"
          pTooltip="Delete"
          class="p-button-link ml-3"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-copy"
          pTooltip="Clone"
          class="p-button-link ml-3"
          (click)="onCloneNote(rowData)"
        ></button>
      </td></tr
  ></ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div
        class=""
        style="text-align: center; font-size: larger; color: #1d428f"
      >
        <i>No records found</i>
      </div>
    </div>
  </ng-template>
</p-table>-->


<div class="card col-12 pt-0 pb-0 mb-2">
    <div class="p-fluid formgrid grid" style="justify-content: space-between">

        <!-- Category Dropdown -->
        <div class="field col-12 md:col-4 xl:col-4 pt-3 mb-3">
            <span class="ui-float-label">
                <p-dropdown [options]="categoriesList"
                            [formControl]="categoryControl"
                            dataKey="categoryId"
                            optionLabel="categoryName"
                            placeholder="Select category"
                            [filter]="true"
                            filterBy="categoryName"
                            [showClear]="true"
                            (onClear)="selectAllCategories()">
                </p-dropdown>
            </span>
        </div>

        <!-- Create Button -->
        <div class="field col-2 md:col-4 lg:col-4 xl:col-3 alignRight pt-3 mb-2">
            <button pButton
                    type="button"
                    label="Create Note Template"
                    icon="pi pi-book"
                    class="ui-button-plain buttonWidth-14 GreyButton"
                    [disabled]="!categoryControl.value"
                    (click)="onAddNotesTemplate()">
            </button>
        </div>

    </div>
</div>

<!-- Notes Table -->
<p-table *ngIf="notesList"
         [columns]="cols"
         [value]="notesList.data"
         selectionMode="single"
         dataKey="notesTemplateId"
         [(selection)]="selectedNotes"
         [paginator]="showRecords"
         [rows]="rows"
         [(first)]="first"
         [style]="{ 'margin-bottom': '20px' }">

    <!-- Header -->
    <ng-template pTemplate="header" let-columns>
        <tr *ngIf="showRecords">
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            <th style="text-align:center">Actions</th>
        </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
                {{ rowData[col.field] }}
            </td>

            <td style="text-align:center">
                <button pButton icon="pi pi-pencil" class="p-button-link"
                        pTooltip="Edit"
                        (click)="onEditNote(rowData)">
                </button>

                <button pButton icon="pi pi-trash" class="p-button-link ml-3"
                        pTooltip="Delete"
                        (click)="onDeleteNote($event, rowData)">
                </button>

                <button pButton icon="pi pi-copy" class="p-button-link ml-3"
                        pTooltip="Clone"
                        (click)="onCloneNote(rowData)">
                </button>
            </td>
        </tr>
    </ng-template>

    <!-- Empty -->
    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white text-center">
            <img src="assets/imagesNew/table_error.png"
                 style="width:10rem;border-radius:50%;padding-top:1rem" />
            <hr />
            <i>No records found</i>
        </div>
    </ng-template>

</p-table>
